// «بیماران» — the list, its toolbar and its states — plus the patient form that
// both the create dialog and the edit drawer render.
export const patients = {
  // ── patients — the list ──────────────────────────────────────────────
  'patients.title': 'بیماران تمرینی',
  'patients.sub': 'بیماران خیالی که برای تمرین ساخته‌اید.',
  'patients.new': 'بیمار جدید',
  'patients.search': 'جستجوی بیمار…',
  'patients.count': '{{count}} بیمار',
  'patients.filters.active': 'فعال',
  'patients.filters.draft': 'پیش‌نویس',
  'patients.filters.archived': 'بایگانی',
  'patients.filters.all': 'همه',
  'patients.sort.label': 'مرتب‌سازی',
  'patients.sort.lastVisit': 'آخرین ویزیت',
  'patients.sort.newest': 'تازه‌ترین',
  'patients.sort.name': 'نام',
  'patients.columns.name': 'نام / برچسب',
  'patients.columns.age': 'سن و جنسیت',
  'patients.columns.complaint': 'شکایت اصلی',
  'patients.columns.visits': 'ویزیت‌ها',
  'patients.columns.lastVisit': 'آخرین ویزیت',
  'patients.columns.status': 'وضعیت',
  'patients.columns.actions': 'عملیات',
  'patients.status.draft': 'پیش‌نویس',
  'patients.status.active': 'فعال',
  'patients.status.archived': 'بایگانی',
  'patients.empty.title': 'هنوز بیماری نساخته‌اید',
  'patients.empty.body': 'بیماران اینجا خیالی‌اند — یکی بسازید و تمرین را شروع کنید.',
  'patients.noMatch.title': 'موردی مطابق جستجو نیست',
  'patients.noMatch.body': 'برای دیدن همهٔ بیماران فیلتر را پاک کنید.',
  'patients.error.title': 'بیماران شما بارگذاری نشد',
  'patients.error.body': 'سرور پاسخ نداد. چیزی از دست نرفته است.',
  'patients.capped': 'بیش از ۱۰۰ بیمار؛ برای یافتن سریع‌تر جستجو کنید.',
  'patients.delete.title': 'این بیمار حذف شود؟',
  'patients.delete.body': '{{entries}} بخش شرح حال، {{visits}} ویزیت و {{threads}} گفتگو با آن حذف می‌شوند. بازگشتی وجود ندارد و پارسهٔ خرج‌شده برنمی‌گردد. برای حفظ کار، به‌جای حذف بایگانی کنید.',
  'patients.delete.confirm': 'حذف دائمی',
  'patients.deleted': 'بیمار حذف شد.',
  'patients.created': 'بیمار ساخته شد.',
  'patients.createdHint': 'شرح حال را بنویسید یا دیکته کنید.',
  'patients.archived': 'بایگانی شد.',
  'patients.unarchived': 'به فهرست فعال برگشت.',
  'patients.actions.open': 'باز کردن پرونده',
  'patients.actions.startVisit': 'شروع ویزیت',
  'patients.actions.chat': 'گفتگو',
  'patients.actions.archive': 'بایگانی',
  'patients.actions.unarchive': 'خروج از بایگانی',
  'patients.actions.delete': 'حذف',
  'patients.actions.clearFilters': 'پاک کردن فیلتر',
  'patients.openLabel': 'باز کردن {{title}}',
  'patients.moreLabel': 'عملیات بیشتر برای {{title}}',
  'patients.unnamed': 'بیمار بی‌نام',
  'patients.visitsCount': '{{count}} ویزیت',
  'patients.noVisits': 'بدون ویزیت',

  // ── the patient form — create and edit ───────────────────────────────
  'caseForm.title.create': 'بیمار تمرینی جدید',
  'caseForm.title.edit': 'ویرایش بیمار',
  'caseForm.fields.title': 'عنوان',
  'caseForm.fields.titlePlaceholder': 'آقای ۵۴ ساله با درد قفسهٔ سینه',
  'caseForm.fields.titleHelper': 'همان چیزی که خودتان این بیمار را در فهرست با آن می‌شناسید.',
  'caseForm.fields.displayName': 'نام ساختگی',
  'caseForm.fields.displayNamePlaceholder': 'آقای رضایی',
  'caseForm.fields.displayNameHelper': 'یک نام بسازید تا پرونده طبیعی خوانده شود. هرگز نام یک فرد واقعی.',
  'caseForm.fields.ageYears': 'سن (سال)',
  'caseForm.fields.ageDisplay': 'سن، با واحد دیگر',
  'caseForm.fields.ageDisplayPlaceholder': '۶ ماهه',
  'caseForm.fields.ageDisplayHelper': 'جایگزین سنِ سال می‌شود؛ برای موردهای کودکان و نوزادان.',
  'caseForm.fields.sex': 'جنسیت',
  'caseForm.fields.bloodType': 'گروه خونی',
  'caseForm.fields.weightKg': 'وزن (کیلوگرم)',
  'caseForm.fields.heightCm': 'قد (سانتی‌متر)',
  'caseForm.fields.chiefComplaint': 'شکایت اصلی',
  'caseForm.fields.chiefComplaintPlaceholder': 'درد فشارندهٔ قفسهٔ سینه از صبح امروز',
  'caseForm.fields.chiefComplaintHelper': 'یک خط. شرح کامل در بخش شرح حال نوشته می‌شود.',
  'caseForm.fields.status': 'وضعیت',
  'caseForm.fields.note': 'یادداشت شخصی',
  'caseForm.submit.create': 'ساختن بیمار',
  'caseForm.submit.edit': 'ذخیرهٔ تغییرات',
  'caseForm.validation.title': 'عنوان الزامی است.',
};

export default patients;
